export default {
  list: [],
  priceLevels: [],
}
